// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1pU5B","title":"styles_title__pUWvW","description":"styles_description__GimJ_","button":"styles_button__45MUb"};